import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';

/**
 * Briques de chrome communes aux onglets du panneau d'aperçu, quel que soit ce
 * qu'ils montrent. Tout ce qui est SPÉCIFIQUE à un type d'onglet vit dans le
 * module de ce type (`DocumentPreviewTab`, `DecisionPreviewTab`) — ici on ne met
 * que ce qui doit rester identique d'un onglet à l'autre.
 */

/** Bouton d'action carré de la rangée de chrome (sortir, télécharger, fermer…). */
export function PreviewIconButton({
  label,
  onClick,
  children,
}: {
  label: string;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      aria-label={label}
      className="h-8 w-8 p-0 text-grey-600 hover:text-grey-900"
    >
      {children}
    </Button>
  );
}
